var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/category-facet-macro.j2"] = require( "macros/category-facet-macro.j2" );
dependencies["macros/alternate-category-facet-macro.j2"] = require( "macros/alternate-category-facet-macro.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["category-navigation-outer.j2"] = require( "category-navigation-outer.j2" );
dependencies["facets/category-facets-outer.j2"] = require( "facets/category-facets-outer.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-facets.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n\n";
env.getTemplate("macros/category-facet-macro.j2", false, "category/templates/facets/category-facets.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("categoryFacetMacro", t_1);
output += "\n";
env.getTemplate("macros/alternate-category-facet-macro.j2", false, "category/templates/facets/category-facets.j2", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("alternateCategoryFacetMacro", t_4);
env.getTemplate("macros/urls.j2", false, "category/templates/facets/category-facets.j2", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(t_7.hasOwnProperty("categoryUrl")) {
var t_10 = t_7.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_10);
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"hideNavigationAndFacets")) {
output += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"renderedFacets")) {
output += "\n\n        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"renderedFacets")), env.opts.autoescape);
output += "\n\n    ";
;
}
else {
output += "\n\n        <div class=\"c-facets-container js-facets dom-facets\" data-qa-facets>\n\n            ";
output += "\n            ";
env.getTemplate("category-navigation-outer.j2", false, "category/templates/facets/category-facets.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"ab")),"SS_FILTERSET") == 1 && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n\n                ";
output += "\n\n            ";
;
}
else {
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"hideFacets")) {
output += "\n\n                ";
env.getTemplate("facets/category-facets-outer.j2", false, "category/templates/facets/category-facets.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n            ";
})});
}
;
}
output += "\n\n        </div>";
})});
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-facets.j2"] , dependencies)